<template>
  <div class="map-locations__locations">
    <div class="map-locations__location" v-for="({name, address, postcode, tel, distance}, key) in sortedLocations" :key="key">
      <div class="map-locations__name">
        {{ name }}
        <span class="map-locations__distance" v-if="distance">{{ distance }} Miles</span>
      </div>
      <div class="map-locations__description">
        {{ address }},
        <span class="map-locations__postcode">{{ postcode }}</span>
        | {{ tel }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Locations',
  props: {
    locations: {
      type: Array,
      default: () => []
    },
    userLocation: {
      type: Object,
      default: () => ({
        lng: 0,
        lat: 0
      })
    }
  },
  computed: {
    sortedLocations () {
      return this.locations.sort((a, b) => a.distance > b.distance ? 1 : a.distance < b.distance ? -1 : 0); // eslint-disable-line
    }
  }
};
</script>
